import type { MouseEvent } from "react";

/**
 * Spread onto a part of a row that is focusable only for its tooltip, such as
 * a chip: a click on it does what a click on the row does. A tooltip never
 * opens on touch, so on a phone the row's own dialog has to say what it says.
 */
export const ROW_CLICK_THROUGH = { "data-row-click": "through" } as const;

/**
 * Whether a click on a row that opens something landed on a control of the
 * row itself (a link, a button, a switch, a chip with a tooltip), which does
 * its own thing. A part marked `ROW_CLICK_THROUGH` is no control, and controls
 * outside the row (the page's focusable main) do not count.
 */
export function onControl(event: MouseEvent<HTMLElement>): boolean {
  const control = (event.target as HTMLElement).closest(
    'a, button, input, [tabindex]:not([data-row-click="through"])',
  );
  return control !== null && event.currentTarget.contains(control);
}
